var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"content":_vm.tooltipContent,"placement":"top"}},[_c('i',{staticClass:"fas fa-question info-tooltip__icon"})])
}
var staticRenderFns = []

export { render, staticRenderFns }